import { useTranslation } from 'react-i18next';

export const PaywallScreen = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        padding: 'var(--space-xl)',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <h1 style={{ fontSize: 'var(--font-2xl)', marginBottom: 'var(--space-md)', color: 'var(--color-accent)' }}>
        {t('paywall.title', 'Upgrade to Pro')}
      </h1>
      <p style={{ color: 'var(--color-text-secondary)', marginBottom: 'var(--space-xl)', maxWidth: 400 }}>
        {t('paywall.subtitle', 'Unlimited links, files, and groups. Coming soon with Stripe.')}
      </p>
    </div>
  );
};
